// src/components/store/sections/hero-banner/HeroV19GlassislandEmeraldMint.tsx
"use client";

import React from "react";
import DynamicHeroVariant from "./DynamicHeroVariant";

export default function HeroV19GlassislandEmeraldMint(props: any) {
  return (
    <DynamicHeroVariant
      variantNumber={19}
      archKey="glass_island"
      archLabel="Frosted Glass Island"
      palName="EmeraldMint"
      grad="from-emerald-500 via-teal-500 to-emerald-700"
      lightBg="bg-emerald-50"
      textCol="text-emerald-700"
      borderCol="border-emerald-200"
      btnCls="bg-emerald-600 hover:bg-emerald-700"
      {...props}
    />
  );
}
